import { fetchV1 } from "../lib/requester/v1";

export function uploadAndProcessDocument(data) {
	return fetchV1("/documents/upload-and-process", { method: "POST", data });
}

export function getLatestDocumentResult() {
	return fetchV1("/documents/latest-result", { method: "GET" });
}

// New Direct S3 Upload API functions
export function getUploadUrlOnly(filename) {
	return fetchV1(`/documents/upload-url-only?filename=${encodeURIComponent(filename)}`, { method: "GET" });
}

export function processFromS3(data) {
	return fetchV1("/documents/process-from-s3", { method: "POST", data });
}

// Direct S3 upload helper function
export async function uploadToS3(uploadUrl, file) {
	const response = await fetch(uploadUrl, {
		method: 'PUT',
		body: file,
		headers: {
			'Content-Type': 'application/pdf'
		}
	});

	if (!response.ok) {
		throw new Error(`S3 upload failed: ${response.status} ${response.statusText}`);
	}

	return response;
}

// Feedback API function
export async function updateFeedback(processingId, questionId, feedbackType) {
	return fetchV1(`/documents/${processingId}/feedback`, { 
		method: "PATCH", 
		data: { questionId, feedbackType } 
	});
}